import {ApiService} from "../api";
import {EducationalInstitutionDTO} from "../../types/DTOs/EducationalInstitutionDTO";
import {AxiosResponse} from "axios";

export class EducationalInstitutionAPI extends ApiService {
    private constructor() {
        super();
    }

    async getAll(): Promise<EducationalInstitutionDTO[]> {
        const response: AxiosResponse<EducationalInstitutionDTO[]> = await this.api.get('/educational-institution');
        return response.data;
    }

    async search(query: string): Promise<EducationalInstitutionDTO[]> {
        const response: AxiosResponse<EducationalInstitutionDTO[]> = await this.api.get('/educational-institution', {
            params: {name: query}
        });
        return response.data;
    }
}
